/** Official SNS destinations (Settings defaults / public fallbacks). */

export const OFFICIAL_YOUTUBE_URL =
  'https://www.youtube.com/@lombokjapanfamily';

export const OFFICIAL_INSTAGRAM_URL =
  'https://www.instagram.com/tamu.lj';

export const OFFICIAL_TIKTOK_URL =
  'https://www.tiktok.com/@lombokjapanfamily';

export const OFFICIAL_FACEBOOK_URL =
  'https://www.facebook.com/tamulombokjapan/';
